import React from 'react';
import Button from 's2s-button';
import PropTypes from 'prop-types';
import CallDetail from './callDetail';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import { getIntlText } from '../js/utilities';
import { track } from 's2s-app-service';
import { colorGrid } from 's2s-themes';

const IncomingCallContainer = styled.div`
  background-color: ${colorGrid.gray0};
  border: 1px solid #e3e5e6;
  border-radius: 4px;
  box-shadow: 0px 16px 24px 0px #08233024;
  box-sizing: border-box;
  margin-left: 16px;
  margin-right: 16px;
  width: calc(100% - 32px);
`;

// const IncomingCallHeader = styled.div`
//   background-color: ${colorGrid.gray2};
//   border-bottom : 1px solid ${colorGrid.gray3};
//   border-top-left-radius : 4px;
//   border-top-right-radius : 4px;
//   color: ${colorGrid.gray8};
//   font-size: 14px;
//   font-weight: 600;
//   line-height: 22px;
//   padding: 12px;
// `;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 16px 0;
`;

const TopButtons = styled.div`
  display: flex;
  justify-content: space-between;
`;

const DeclineButton = styled(Button)`
  background-color: #c70816;
  display: flex;
  font-family: Open Sans;
  font-weight: 700;
  justify-content: center;
  letter-spacing: 1.25px;
  margin-right: 16px;
  text-transform: uppercase;
  width: 50%;
  
  :hover {
    background-color: #85050f;
  };
`;

const AcceptButton = styled(Button)`
  background-color: #099f24;
  display: flex;
  font-family: Open Sans;
  font-weight: 700;
  justify-content: center;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  width: 50%;
  
  :hover {
    background-color: #066a18;
  };
`;

const VoicemailButton = styled(Button)`
  background-color: ${colorGrid.gray0};
  border: 1px solid #a7b4e9;
  color: #243991;
  display: flex;
  font-family: Open Sans;
  font-weight: 700;
  justify-content: center;
  letter-spacing: 1.25px;
  margin-top: 16px;
  margin-bottom: 20px;
  text-transform: uppercase;
  
  :hover {
    background-color: #d3d9f4;
  }
`;

const StyledCallDetail = styled(CallDetail)`
  background-color: ${colorGrid.gray0};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;

const IncomingCall = injectIntl((props) => {
  track("incoming_call", "received");
  const acceptOnClick = () => {
    track("incoming_call_accept", "clicked");
    props.cbOnClick('incoming-accept', props.callDetails);
  };

  const declineOnClick = () => {
    track("incoming_call_decline", "clicked");
    props.cbOnClick('incoming-decline', props.callDetails);
  };

  const toVoicemailOnClick = () => {
    track("incoming_call_toVoicemail", "clicked");
    if (props.vmEnabled) {
      props.cbOnClick('incoming-to-voicemail', props.callDetails);
    }
  };

  //console.log('CD: props', props.callDetails);
  return (
    <IncomingCallContainer className='incomingCallContainer'>
      {/* <IncomingCallHeader className='header' >
        {getIntlText(props.intl, 'INCOMINGCALL-HEADER', 'Incoming Call')}
      </IncomingCallHeader> */}
      <StyledCallDetail
        className='callDetail'
        cbClick={() => {}}
        callId={props.callDetails.callId}
        callerName={props.callDetails.callerName}
        callerNumber={props.callDetails.callerNumber}
        callStatus={props.callDetails?.callStatus?.toLowerCase()}
        callStatusText={getIntlText(props.intl, 'ACTIVECALL-STATUS-' + props.callDetails?.callStatus?.toUpperCase(), props.callDetails.callStatus)}
        direction="inbound"
        isDate={false}
      />
      <ButtonContainer className='buttonContainer'>
        <TopButtons>
          <DeclineButton className="decline"
            buttonLabel={getIntlText(props.intl, 'INCOMINGCALL-DECLINE', 'Decline')}
            buttonSize={'large'}
            buttonType={'primaryRed'}
            cbClick={declineOnClick}
          />
          <AcceptButton className="accept"
            buttonLabel={getIntlText(props.intl, 'INCOMINGCALL-ACCEPT', 'Accept')}
            cbClick={acceptOnClick}
            buttonSize={'large'}
            buttonType={'primaryGreen'}
          />
        </TopButtons>
        <VoicemailButton
          className="voicemail"
          buttonLabel={getIntlText(props.intl, 'INCOMINGCALL-VOICEMAIL', 'Send to Voicemail')}
          buttonSize={'large'}
          buttonType={'ghost'}
          cbClick={toVoicemailOnClick}
          isDisabled={!props.vmEnabled}
        />
      </ButtonContainer>

    </IncomingCallContainer>
  );

});

IncomingCall.propTypes = {
  callDetails: PropTypes.object,
  cbOnClick: PropTypes.func,
  vmEnabled: PropTypes.bool,
  intl: PropTypes.object
};

IncomingCall.defaultProps = {
  vmEnabled: true
};

export default IncomingCall;
